/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            let handle = button.dataset.collection;
            [].forEach.call(this.buttons, function(el) {
              el.classList.remove('active');
            });

            button.classList.add('active');

            if (handle) {
              this.toggleCollection(handle);
            }

            event.preventDefault();
          });
        });
      }, 20);
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);

          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }
    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return;

      // Récupérer l'instance Flickity existante
      const flkty = Flickity.data(slider);

      // Récupérer les options actuelles de Flickity avant de le détruire
      const flickityOptions = {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        cellSelector: '.carousel__slide'
      };

      // 1. Détruire Flickity si existant
      if (flkty) {
        flkty.destroy();
      }

      // 2. Mettre à jour les classes sur TOUS les éléments
      const allItems = slider.querySelectorAll('.columns[data-collection]');
      allItems.forEach(el => {
        if (el.getAttribute('data-collection') === handle) {
          el.classList.add('carousel__slide');
        } else {
          el.classList.remove('carousel__slide');
        }
      });

      // 3. Recréer Flickity
      const newFlkty = new Flickity(slider, flickityOptions);

      // 4. Configurer les boutons de navigation
      const prevButton = slider.querySelector('.flickity-prev');
      const nextButton = slider.querySelector('.flickity-next');

      if (prevButton && nextButton) {
        // Supprimer les anciens event listeners en clonant les boutons
        const newPrevButton = prevButton.cloneNode(true);
        const newNextButton = nextButton.cloneNode(true);
        prevButton.parentNode.replaceChild(newPrevButton, prevButton);
        nextButton.parentNode.replaceChild(newNextButton, nextButton);

        newPrevButton.addEventListener('click', () => newFlkty.previous());
        newNextButton.addEventListener('click', () => newFlkty.next());
      }

      // 5. Mettre à jour la barre de progression si elle existe
      const progressBar = slider.parentNode.querySelector('.flickity-progress--bar');
      if (progressBar) {
        newFlkty.on('scroll', function(progress) {
          progress = Math.max(0, Math.min(1, progress));
          progressBar.style.width = progress * 100 + '%';
        });
      }

      // 6. Sélectionner le premier slide
      newFlkty.select(0, false, true);
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
